"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryRunAnchoredTextBox = exports.HistoryRunAnchoredPicture = exports.HistoryRunSection = exports.HistoryRunParagraph = exports.HistoryRunFieldResultEnd = exports.HistoryRunFieldCodeEnd = exports.HistoryRunFieldCodeStart = exports.HistoryRunInlinePicture = exports.HistoryRun = void 0;
var tslib_1 = require("tslib");
var rich_utils_1 = require("../rich-utils");
var run_type_1 = require("../runs/run-type");
var HistoryRun = (function () {
    function HistoryRun(type, charPropsBundle, offsetAtStartDocument, text) {
        this.type = type;
        this.charPropsBundle = charPropsBundle;
        this.offsetAtStartDocument = offsetAtStartDocument;
        this.text = text;
    }
    return HistoryRun;
}());
exports.HistoryRun = HistoryRun;
var HistoryRunInlinePicture = (function (_super) {
    tslib_1.__extends(HistoryRunInlinePicture, _super);
    function HistoryRunInlinePicture(offsetAtStartDocument, charPropsBundle, picInfo, options) {
        var _this = _super.call(this, run_type_1.RunType.InlinePictureRun, charPropsBundle, offsetAtStartDocument, rich_utils_1.RichUtils.specialCharacters.ObjectMark) || this;
        _this.picInfo = picInfo;
        _this.options = options;
        return _this;
    }
    return HistoryRunInlinePicture;
}(HistoryRun));
exports.HistoryRunInlinePicture = HistoryRunInlinePicture;
var HistoryRunFieldCodeStart = (function (_super) {
    tslib_1.__extends(HistoryRunFieldCodeStart, _super);
    function HistoryRunFieldCodeStart(type, charPropsBundle, offsetAtStartDocument, text, showCode, startPosition, separatorPosition, endPosition, hyperlinkInfo) {
        var _this = _super.call(this, type, charPropsBundle, offsetAtStartDocument, text) || this;
        _this.showCode = showCode;
        _this.startPosition = startPosition;
        _this.separatorPosition = separatorPosition;
        _this.endPosition = endPosition;
        _this.hyperlinkInfo = hyperlinkInfo;
        return _this;
    }
    return HistoryRunFieldCodeStart;
}(HistoryRun));
exports.HistoryRunFieldCodeStart = HistoryRunFieldCodeStart;
var HistoryRunFieldCodeEnd = (function (_super) {
    tslib_1.__extends(HistoryRunFieldCodeEnd, _super);
    function HistoryRunFieldCodeEnd() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HistoryRunFieldCodeEnd;
}(HistoryRun));
exports.HistoryRunFieldCodeEnd = HistoryRunFieldCodeEnd;
var HistoryRunFieldResultEnd = (function (_super) {
    tslib_1.__extends(HistoryRunFieldResultEnd, _super);
    function HistoryRunFieldResultEnd() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HistoryRunFieldResultEnd;
}(HistoryRun));
exports.HistoryRunFieldResultEnd = HistoryRunFieldResultEnd;
var HistoryRunParagraph = (function (_super) {
    tslib_1.__extends(HistoryRunParagraph, _super);
    function HistoryRunParagraph(type, charPropsBundle, parPropsBundle, offsetAtStartDocument, text, applyDirectlyToNewParagraph) {
        var _this = _super.call(this, type, charPropsBundle, offsetAtStartDocument, text) || this;
        _this.applyDirectlyToNewParagraph = applyDirectlyToNewParagraph;
        _this.parPropsBundle = parPropsBundle;
        return _this;
    }
    return HistoryRunParagraph;
}(HistoryRun));
exports.HistoryRunParagraph = HistoryRunParagraph;
var HistoryRunSection = (function (_super) {
    tslib_1.__extends(HistoryRunSection, _super);
    function HistoryRunSection(charPropsBundle, parPropsBundle, section, offsetAtStartDocument, applyDirectlyToNewParagraph) {
        var _this = _super.call(this, run_type_1.RunType.SectionRun, charPropsBundle, parPropsBundle, offsetAtStartDocument, rich_utils_1.RichUtils.specialCharacters.SectionMark, applyDirectlyToNewParagraph) || this;
        _this.sectionProperties = section.sectionProperties;
        _this.headers = section.headers.clone();
        _this.footers = section.footers.clone();
        return _this;
    }
    return HistoryRunSection;
}(HistoryRunParagraph));
exports.HistoryRunSection = HistoryRunSection;
var HistoryRunAnchoredPicture = (function (_super) {
    tslib_1.__extends(HistoryRunAnchoredPicture, _super);
    function HistoryRunAnchoredPicture(charPropsBundle, picInfo, offsetAtStartDocument) {
        var _this = _super.call(this, run_type_1.RunType.AnchoredPictureRun, charPropsBundle, offsetAtStartDocument, rich_utils_1.RichUtils.specialCharacters.ObjectMark) || this;
        _this.picInfo = picInfo;
        return _this;
    }
    return HistoryRunAnchoredPicture;
}(HistoryRun));
exports.HistoryRunAnchoredPicture = HistoryRunAnchoredPicture;
var HistoryRunAnchoredTextBox = (function (_super) {
    tslib_1.__extends(HistoryRunAnchoredTextBox, _super);
    function HistoryRunAnchoredTextBox(charPropsBundle, textBoxInfo, offsetAtStartDocument) {
        var _this = _super.call(this, run_type_1.RunType.AnchoredTextBoxRun, charPropsBundle, offsetAtStartDocument, rich_utils_1.RichUtils.specialCharacters.ObjectMark) || this;
        _this.textBoxInfo = textBoxInfo;
        return _this;
    }
    return HistoryRunAnchoredTextBox;
}(HistoryRun));
exports.HistoryRunAnchoredTextBox = HistoryRunAnchoredTextBox;
